<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="cohortValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-input class="mb-3"
                :label="$t('common.name')"
                label-classes="form-control-label required"
                :placeholder="$t('common.name')"
                v-model="value.name"
                name="name"
                rules="required"
                :error="errors.get('name')">
            </base-input>

            <base-select class="mb-4" v-if="!$auth.user.owner_id"
                :label="$t('common.owner')"
                :placeholder="$t('common.owner')"
                v-model="value.owner_id"
                :options="owners"
                @input="errors.clear('owner_id')"
                :error="errors.get('owner_id')"
            >
            </base-select>

            <base-select class="mb-4" v-if="value.status != 'archived'"
                :label="$t('common.status')"
                :placeholder="$t('common.status')"
                v-model="value.status"
                :options="statusOptions"
                :sort="false"
            >
            </base-select>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? $t('common.update') : $t('common.create') }}
                </base-button>

                <base-button outline 
                    type="primary"
                    :disabled="errors.any() || invalid"
                    @click="next"
                >
                    {{ $t('common.more') }}
                </base-button>
            </div>

            <div class="text-center mt-3">
                <base-button type="link" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true
            },
            errors: {
                type: Object,
                required: true
            },
            modal: {
                type: Object,
                default: null
            },
            statusOptions: {
                type: Object,
                default: true
            },
            owners: {
                type: Object,
                required: true
            },
        },

        created() {
            this.errors.setValidator('cohortValidator', this)
        },

        methods: {

            submit() {
                this.$emit('input', { ...this.value})
            },

            next() {
                this.$emit('next')
                this.submit()
            }
        }
    }
</script>
